/* Sjednocene cart skripty (drive dve temer identicke inline kopie v snippets/cart-drawer.liquid
   a sections/main-cart-items.liquid; na /cart bezely obe soucasne = dvojite listenery,
   dvojity fetch monkey-patch a 5 MutationObserveru).
   Cast 1: variantni obrazek v kosiku podle zvolenych prichuti.
   Cast 2: oprava cen s float artefakty (3+ desetinnych mist) v kosiku. */
(function () {
  if (window.__yerbCartEnhancements) return;
  window.__yerbCartEnhancements = true;

  /* ---- Cast 1: obrazky podle prichuti ---- */
  (function () {
    const productDataCache = {};
    let emptyCartRetries = 0;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateCartImagesBasedOnFlavors);
    } else {
      updateCartImagesBasedOnFlavors();
    }

    document.addEventListener('cart:updated', () => {
      setTimeout(updateCartImagesBasedOnFlavors, 100);
    });

    document.addEventListener('cart-drawer:open', () => {
      setTimeout(updateCartImagesBasedOnFlavors, 100);
    });

    const observeCart = () => {
      const cartContainers = document.querySelectorAll('#CartDrawer-CartItems, #main-cart-items, .cart-drawer-form, .cart-contents');

      cartContainers.forEach(container => {
        if (!container) return;

        const observer = new MutationObserver((mutations) => {
          const hasCartItemChanges = mutations.some(mutation => {
            return Array.from(mutation.addedNodes).some(node =>
              node.nodeType === 1 && (
                node.classList?.contains('cart-item') ||
                node.querySelector?.('.cart-item')
              )
            );
          });

          if (hasCartItemChanges) {
            setTimeout(updateCartImagesBasedOnFlavors, 200);
          }
        });

        observer.observe(container, {
          childList: true,
          subtree: true
        });
      });
    };

    setTimeout(observeCart, 500);

    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const url = args[0];

      return originalFetch.apply(this, args).then(response => {
        if (typeof url === 'string' && (
            url.includes('/cart/add') ||
            url.includes('/cart/update') ||
            url.includes('/cart/change')
          )) {
          setTimeout(updateCartImagesBasedOnFlavors, 300);
        }
        return response;
      });
    };

    async function updateCartImagesBasedOnFlavors() {
      const cartItems = document.querySelectorAll('.cart-item, [id^="CartItem-"], [id^="CartDrawer-Item-"]');

      if (cartItems.length === 0) {
        /* prazdny kosik: par pokusu na pomaly render, ale zadny vecny polling */
        if (emptyCartRetries < 10) {
          emptyCartRetries++;
          setTimeout(updateCartImagesBasedOnFlavors, 500);
        }
        return;
      }
      emptyCartRetries = 0;

      for (const cartItem of cartItems) {
        try {
          const productLink = cartItem.querySelector('.cart-item-name[href*="/products/"], a[href*="/products/"]');
          if (!productLink) {
            continue;
          }

          const productUrl = productLink.getAttribute('href');
          const productHandle = productUrl.split('/products/')[1]?.split('?')[0]?.split('#')[0];
          if (!productHandle) {
            continue;
          }

          const flavorProperties = [];
          const propertyItems = cartItem.querySelectorAll('.cart-item-properties li, .product-option');

          propertyItems.forEach(prop => {
            const text = prop.textContent.trim();
            if (text.includes('Příchuť')) {
              const flavorName = text.split(':')[1]?.trim();
              if (flavorName) {
                flavorProperties.push(flavorName);
              }
            }
          });

          if (flavorProperties.length > 0) {
            const allSame = flavorProperties.every(f => f === flavorProperties[0]);

            if (allSame) {
              const targetFlavor = flavorProperties[0];

              const productData = await fetchProductData(productHandle);
              if (!productData) continue;

              const matchingVariant = productData.variants.find(v =>
                v.title.trim().toLowerCase() === targetFlavor.toLowerCase()
              );

              if (matchingVariant && matchingVariant.featured_image) {
                const cartImage = cartItem.querySelector('.cart-item-image, img');
                if (cartImage) {
                  const currentSrc = cartImage.getAttribute('src');
                  const newSrc = matchingVariant.featured_image.src;

                  if (!currentSrc.includes(matchingVariant.featured_image.src.split('?')[0])) {
                    cartImage.src = newSrc;
                    cartImage.srcset = newSrc;
                    cartImage.alt = matchingVariant.title;
                  }
                }
              }
            }
          }
        } catch (error) {

        }
      }
    }

    async function fetchProductData(handle) {
      if (productDataCache[handle]) {
        return productDataCache[handle];
      }

      try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) throw new Error('Failed to fetch product');

        const data = await response.json();
        productDataCache[handle] = data;
        return data;
      } catch (error) {
        return null;
      }
    }

    window.updateCartImagesByFlavor = updateCartImagesBasedOnFlavors;
  })();

  /* ---- Cast 2: oprava cen s float artefakty ---- */
  (function () {
    function getCurrencyCode() {
      if (window.Shopify?.currency?.active) {
        return window.Shopify.currency.active;
      }
      if (window.Shopify?.currency?.iso_code) {
        return window.Shopify.currency.iso_code;
      }
      const currencyEl = document.querySelector('[data-currency], [data-shop-currency]');
      if (currencyEl) {
        return currencyEl.dataset.currency || currencyEl.dataset.shopCurrency;
      }
      const cartCurrency = document.querySelector('.cart-drawer [data-currency], cart-items [data-currency]');
      if (cartCurrency) {
        return cartCurrency.dataset.currency;
      }
      return 'CZK';
    }

    function formatPrice(priceText, currencyCode) {
      if (!priceText) return priceText;

      const cleanText = priceText.toString().trim();

      const numberMatch = cleanText.match(/[\d,]+\.?\d*/);
      if (!numberMatch) return priceText;

      let numberStr = numberMatch[0].replace(/,/g, '');
      const number = parseFloat(numberStr);

      if (isNaN(number)) return priceText;

      let formatted;
      const upperCurrency = (currencyCode || '').toUpperCase();

      if (upperCurrency === 'CZK') {
        formatted = Math.round(number).toString();
        if (cleanText.includes('Kč') || cleanText.includes('CZK')) {
          formatted += ' Kč';
        }
      } else {
        formatted = number.toFixed(2);
        formatted = formatted.replace(/\.?0+$/, '');
        const currencyMatch = cleanText.match(/([A-Z]{3}|[^\d\s,\.]+)/);
        if (currencyMatch && !formatted.includes(currencyMatch[0])) {
          formatted += ' ' + currencyMatch[0];
        }
      }

      return formatted;
    }

    function fixPricesInElement(element) {
      if (!element) return;

      const currencyCode = getCurrencyCode();

      const priceSelectors = [
        '.price-item',
        '.cart-item-final-price',
        '.cart-item-old-price',
        '.totals-subtotal-value',
        '.unit-price .price-item',
        '.price--end',
        '.cart-item-discounted-prices .price'
      ];

      priceSelectors.forEach(selector => {
        const priceElements = element.querySelectorAll(selector);
        priceElements.forEach(el => {
          if (el.dataset.priceFormatted === 'true') return;

          const text = el.textContent.trim();
          const hasTooManyDecimals = text.match(/\d+\.\d{3,}/);

          if (hasTooManyDecimals) {
            const formatted = formatPrice(text, currencyCode);
            if (formatted !== text) {
              el.textContent = formatted;
              el.dataset.priceFormatted = 'true';
            }
          }
        });
      });
    }

    function fixAllPrices() {
      const cartDrawer = document.querySelector('#CartDrawer, .cart-drawer');
      if (cartDrawer) {
        fixPricesInElement(cartDrawer);
      }

      const mainCart = document.querySelector('#main-cart-items, cart-items');
      if (mainCart) {
        fixPricesInElement(mainCart);
      }

      const priceComponents = document.querySelectorAll('.price__container, .price-item');
      priceComponents.forEach(component => {
        fixPricesInElement(component);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(fixAllPrices, 100);
      });
    } else {
      setTimeout(fixAllPrices, 100);
    }

    document.addEventListener('cart:updated', () => {
      setTimeout(fixAllPrices, 200);
    });

    document.addEventListener('cart-drawer:open', () => {
      setTimeout(fixAllPrices, 200);
    });

    const priceObserver = new MutationObserver((mutations) => {
      let shouldFix = false;
      mutations.forEach(mutation => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const target = mutation.target;
          if (target.textContent && target.textContent.match(/\d+\.\d{3,}/)) {
            shouldFix = true;
          }
        }
      });
      if (shouldFix) {
        fixAllPrices();
      }
    });

    setTimeout(() => {
      const cartContainers = document.querySelectorAll('#CartDrawer, #main-cart-items, .price__container, .cart-item-price-wrapper');
      cartContainers.forEach(container => {
        if (container) {
          priceObserver.observe(container, {
            childList: true,
            subtree: true,
            characterData: true
          });
        }
      });
    }, 500);
  })();
})();
